/**
 * CallSyncCRMContactLeadSearchInputBoxContainer is an AltContainer for <CallSyncCRMContactLeadSearchInputBox/>
 */
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';

import CrmSyncAccountAndOpportunitiesStore from 'stores/crm/CrmSyncAccountAndOpportunitiesStore';
import CrmSyncContactsAndLeadsPrefixSearchStore from 'stores/crm/CrmSyncContactsAndLeadsPrefixSearchStore';
import CallSyncCRMContactLeadSearchInputBox from 'components/pure/call-card/sync-crm/CallSyncCRMContactLeadSearchInputBox';

class CallSyncCRMContactLeadSearchInputBoxContainer extends React.Component {
  static getStores() {
    return [CrmSyncContactsAndLeadsPrefixSearchStore, CrmSyncAccountAndOpportunitiesStore];
  }

  static getPropsFromStores() {
    const contactsAndLeadsStoreState = CrmSyncContactsAndLeadsPrefixSearchStore.getState();
    const accountAndOpportunitiesStoreState = CrmSyncAccountAndOpportunitiesStore.getState();
    return {
      contactsOptions: contactsAndLeadsStoreState.get('options'),
      options: contactsAndLeadsStoreState.get('options'),
      total: contactsAndLeadsStoreState.get('total'),
      numReturned: contactsAndLeadsStoreState.get('numReturned'),
      values: contactsAndLeadsStoreState.get('values').toArray(),
      loading: contactsAndLeadsStoreState.get('loading'),
      accountAndOpportunitiesValues: accountAndOpportunitiesStoreState.get('values'),
    };
  }

  render() {
    return (
      <AltContainer>
        <CallSyncCRMContactLeadSearchInputBox {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(CallSyncCRMContactLeadSearchInputBoxContainer);
